<div class="d-flex flex-row justify-content-center" *ngIf="!isAndroid">
    <button *ngIf="!this.synth.speaking else template" (click)="read()"><i class="fas fa-play playbtn"></i></button>

    <ng-template #template>
        <button (click)="stopReading()"><i class="fas fa-stop stopbtn"></i></button>        
        <button *ngIf="!pauseValue else pauseTemplate" (click)="pause()"><i class="fas fa-pause pausebtn"></i></button>
        <ng-template #pauseTemplate>
            <button (click)="continue()"><i class="fas fa-play playbtn"></i></button>
        </ng-template>
    </ng-template>
</div>   

<div class="d-flex flex-row justify-content-center" *ngIf="isAndroid">
    <button *ngIf="!this.synth.speaking else template" (click)="read()"><i class="fas fa-play playbtn"></i></button>

    <ng-template #template>
        <button (click)="stopReading()"><i class="fas fa-stop stopbtn"></i></button>
    </ng-template>
</div>     

